import {$axios} from '../../assets/js/$axios'
// axios.defaults.baseURL = 'http://39.104.71.153:8066';
import moment from 'moment'
import {
  debug
} from 'util';

function coculateTime(moment, timeTree) {
  timeTree.forEach(element => {
    let now = moment().unix();
    let time = moment(element.interactionDate).unix();
    if ((now - time) / 86400 > 1) { //当前时间大于一天
      element.interactionDate = moment(element.interactionDate).month() + "月" + moment(element.interactionDate).day() + '日'
    } else if ((now - time) >= 180 && (now - time) <= 86400) { //小于一天 大于三分钟
      element.interactionDate = moment(element.interactionDate).hour() + ":" + moment(element.interactionDate).minute()
    } else if ((now - time) < 180) { //小于三分钟
      element.interactionDate = '刚刚'
    }
  });
}
export default {
  state: {
    memberinteraction: [], //会话页面消息列表
    birthdaynotify: [{
        birthDayInfo: "3天后过生日(4月1日)",
        handled: false,
        lastArriveDate: "2018-05-23 15:06:53",
        memberCode: "M0000001",
        memberId: 1,
        memberImgurl: "https://pro.modao.cc/uploads3/images/1767/17679579/raw_1520579438.png",
        memberName: "王美丽",
        memberNickName: "WML",
        phone: "13800138000",
        checked:false
      },
      {
        birthDayInfo: "3天后过生日(4月1日)",
        handled: false,
        lastArriveDate: "2018-05-23 15:06:53",
        memberCode: "M0000001",
        memberId: 1,
        memberImgurl: "https://pro.modao.cc/uploads3/images/1767/17679579/raw_1520579438.png",
        memberName: "王美丽",
        memberNickName: "WML",
        phone: "13800138000",
        checked:false
      }, {
        birthDayInfo: "3天后过生日(4月1日)",
        handled: false,
        lastArriveDate: "2018-05-23 15:06:53",
        memberCode: "M0000001",
        memberId: 1,
        memberImgurl: "https://pro.modao.cc/uploads3/images/1767/17679579/raw_1520579438.png",
        memberName: "王美丽",
        memberNickName: "WML",
        phone: "13800138000",
        checked:false
      }, {
        birthDayInfo: "3天后过生日(4月1日)",
        handled: true,
        lastArriveDate: "2018-05-23 15:06:53",
        memberCode: "M0000001",
        memberId: 1,
        memberImgurl: "https://pro.modao.cc/uploads3/images/1767/17679579/raw_1520579438.png",
        memberName: "王美丽",
        memberNickName: "WML",
        phone: "13800138000",
        checked:false
      }
    ],
    selected: [],
    headerName: '',
    count: 0
  },
  mutations: {
    update_memberinteraction(state, obj) {
      state.memberinteraction = obj
      coculateTime(moment, state.memberinteraction)
    },
    update_birthdaynotify(state, obj) {
      // state.birthdaynotify = obj
      state.birthdaynotify.forEach(element => {
        element.show = false
        // element.handled = true
      })
    },
    switch_selected(state, obj) {
      state.selected = obj
    },
    swith_headerName(state, obj) {
      state.headerName = obj
    },
    update_count(state, obj) {
      state.count = obj
    }
  },
  getters: {
    countOut(state) {
      return state.count
    }
  },
  actions: {
    memberinteraction: () => {
      let menberId = {
        "memberId": "1"
      }
      $axios({
        methods:'post',
        data:menberId,
        url:'/crm/memberinteraction',
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      }).then(res=>{
        this.a.mutations.update_memberinteraction(this.a.state, data.data.data)
      })
      // $axios.post('/crm/memberinteraction', menberId).then(
      //   data => {
      //     this.a.mutations.update_memberinteraction(this.a.state, data.data.data)
      //   }
      // )
    },
    birthdaynotify: (state,times) => {
      let period = times
      console.log(period)
      $axios({
        method: "post",
        data: {
          fromDate:period.fromDate,
          toDate:period.toDate
        },
        url: 'crm/birthdaynotifyd',
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      }).then(res => {
        if(res.data.scode == "0"){
        }
      });
      
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/chat/chat.js